import React from 'react'
import { refreshCache } from 'lib/cache-utils'
import { errorMessage, successMessage } from 'lib/flash-message'
import { DropdownButton, MenuItem } from 'react-bootstrap'

import * as css from './admin-tool.scss'

const AdminTool = () => {
  const handleClearCache = () => {
    refreshCache([{ name: window.location.href }])
      .then((resp) => {
        successMessage(
          'Success! Cache for this page will be cleared in a few minutes.'
        )
      })
      .catch((error) => {
        errorMessage('Uh oh...there was an error try to clear the cache!')
      })
  }

  return (
    <div className={css.adminButton}>
      <DropdownButton bsSize="small" bsStyle="default" pullRight>
        <MenuItem onClick={handleClearCache}>Clear Cache</MenuItem>
      </DropdownButton>
    </div>
  )
}

export default AdminTool
